import { render } from "./ConfigRoundAddEditDialog.vue?vue&type=template&id=3fec5033"
import script from "./ConfigRoundAddEditDialog.vue?vue&type=script&lang=js"
export * from "./ConfigRoundAddEditDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__